export const CHAT_MAX_FILE_MB = 200;
export const CHAT_MAX_FILE_BYTES = CHAT_MAX_FILE_MB * 1024 * 1024;
